

export const isStatusSucessoNotaFiscal = (status: number) => {
    return status === 100 || status === -100;
}

export const isStatusCanceladoNotaFiscal = (status: number) => {
    return status === 101;
}